/**
 * Typo align
 */
export var Justifiable;
(function (Justifiable) {
    Justifiable["JUSTIFIED_CENTER"] = "JUSTIFIED_CENTER";
    Justifiable["JUSTIFIED_START"] = "JUSTIFIED_START";
    Justifiable["JUSTIFIED_END"] = "JUSTIFIED_END";
    Justifiable["SPACE_BETWEEN"] = "SPACE_BETWEEN";
})(Justifiable || (Justifiable = {}));
export var Justify;
(function (Justify) {
    Justify["CENTER"] = "CENTER";
    Justify["START"] = "START";
    Justify["END"] = "END";
    Justify["SPACE_BETWEEN"] = "SPACE_BETWEEN";
    Justify["SPACE_AROUND"] = "SPACE_AROUND";
    Justify["SPACE_EVENLY"] = "SPACE_EVENLY";
})(Justify || (Justify = {}));
/**
 * Returns justifyContent style depending on justify type
 * @param justifyContent {Justifiable|string} - justify type
 * @returns {string} - Justify value
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var getJustifyStyle = function (justifyContent) {
    switch (justifyContent) {
        case 'JUSTIFIED_CENTER':
            return 'center';
        case 'JUSTIFIED_START':
            return 'flex-start';
        case 'JUSTIFIED_END':
            return 'flex-end';
        case 'SPACE_BETWEEN':
            return 'space-between';
        default:
            return 'flex-start';
    }
};
export var getJustifyClassName = function (justifyContent) {
    switch (justifyContent) {
        case 'JUSTIFIED_CENTER':
            return 'centered';
        case 'CENTER':
            return 'justified-center';
        case 'JUSTIFIED_START':
            return 'justified-start';
        case 'START':
            return 'justified-start';
        case 'JUSTIFIED_END':
            return 'justified-end';
        case 'END':
            return 'justified-end';
        case 'SPACE_BETWEEN':
            return 'spaced-between';
        case 'SPACE_AROUND':
            return 'spaced-around';
        case 'SPACE_EVENLY':
            return 'spaced-evenly';
        default:
            return 'justified-start';
    }
};
export var getJustifiedClassName = function (justifyContent) {
    switch (justifyContent) {
        case 'ALIGNED_CENTER':
            return 'justified-center';
        case 'ALIGNED_START':
            return 'justified-start';
        case 'ALIGNED_END':
            return 'justified-end';
        default:
            return 'justified-start';
    }
};
export var getJustifySelfClassName = function (justifyContent) {
    switch (justifyContent) {
        case 'ALIGNED_CENTER':
            return 'justified-self-center';
        case 'ALIGNED_START':
            return 'justified-self-start';
        case 'ALIGNED_END':
            return 'justified-selfend';
        default:
            return 'justified-selfstart';
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSnVzdGlmaWFibGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9vYmplY3RzL2ZhY2V0cy9KdXN0aWZpYWJsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLFdBS1g7QUFMRCxXQUFZLFdBQVc7SUFDckIsb0RBQXFDLENBQUE7SUFDckMsa0RBQW1DLENBQUE7SUFDbkMsOENBQStCLENBQUE7SUFDL0IsOENBQStCLENBQUE7QUFDakMsQ0FBQyxFQUxXLFdBQVcsS0FBWCxXQUFXLFFBS3RCO0FBRUQsTUFBTSxDQUFOLElBQVksT0FPWDtBQVBELFdBQVksT0FBTztJQUNqQiw0QkFBaUIsQ0FBQTtJQUNqQiwwQkFBZSxDQUFBO0lBQ2Ysc0JBQVcsQ0FBQTtJQUNYLDBDQUErQixDQUFBO0lBQy9CLHdDQUE2QixDQUFBO0lBQzdCLHdDQUE2QixDQUFBO0FBQy9CLENBQUMsRUFQVyxPQUFPLEtBQVAsT0FBTyxRQU9sQjtBQVFEOzs7O0dBSUc7QUFDSCw2RUFBNkU7QUFDN0UsTUFBTSxDQUFDLElBQU0sZUFBZSxHQUFHLFVBQUMsY0FBdUI7SUFDckQsUUFBUSxjQUFjLEVBQUU7UUFDdEIsS0FBSyxrQkFBa0I7WUFDckIsT0FBTyxRQUFRLENBQUE7UUFDakIsS0FBSyxpQkFBaUI7WUFDcEIsT0FBTyxZQUFZLENBQUE7UUFDckIsS0FBSyxlQUFlO1lBQ2xCLE9BQU8sVUFBVSxDQUFBO1FBQ25CLEtBQUssZUFBZTtZQUNsQixPQUFPLGVBQWUsQ0FBQTtRQUN4QjtZQUNFLE9BQU8sWUFBWSxDQUFBO0tBQ3RCO0FBQ0gsQ0FBQyxDQUFBO0FBRUQsTUFBTSxDQUFDLElBQU0sbUJBQW1CLEdBQUcsVUFBQyxjQUF1QjtJQUN6RCxRQUFRLGNBQWMsRUFBRTtRQUN0QixLQUFLLGtCQUFrQjtZQUNyQixPQUFPLFVBQVUsQ0FBQTtRQUNuQixLQUFLLFFBQVE7WUFDWCxPQUFPLGtCQUFrQixDQUFBO1FBQzNCLEtBQUssaUJBQWlCO1lBQ3BCLE9BQU8saUJBQWlCLENBQUE7UUFDMUIsS0FBSyxPQUFPO1lBQ1YsT0FBTyxpQkFBaUIsQ0FBQTtRQUMxQixLQUFLLGVBQWU7WUFDbEIsT0FBTyxlQUFlLENBQUE7UUFDeEIsS0FBSyxLQUFLO1lBQ1IsT0FBTyxlQUFlLENBQUE7UUFDeEIsS0FBSyxlQUFlO1lBQ2xCLE9BQU8sZ0JBQWdCLENBQUE7UUFDekIsS0FBSyxjQUFjO1lBQ2pCLE9BQU8sZUFBZSxDQUFBO1FBQ3hCLEtBQUssY0FBYztZQUNqQixPQUFPLGVBQWUsQ0FBQTtRQUN4QjtZQUNFLE9BQU8saUJBQWlCLENBQUE7S0FDM0I7QUFDSCxDQUFDLENBQUE7QUFFRCxNQUFNLENBQUMsSUFBTSxxQkFBcUIsR0FBRyxVQUFDLGNBQXVCO0lBQzNELFFBQVEsY0FBYyxFQUFFO1FBQ3RCLEtBQUssZ0JBQWdCO1lBQ25CLE9BQU8sa0JBQWtCLENBQUE7UUFDM0IsS0FBSyxlQUFlO1lBQ2xCLE9BQU8saUJBQWlCLENBQUE7UUFDMUIsS0FBSyxhQUFhO1lBQ2hCLE9BQU8sZUFBZSxDQUFBO1FBQ3hCO1lBQ0UsT0FBTyxpQkFBaUIsQ0FBQTtLQUMzQjtBQUNILENBQUMsQ0FBQTtBQUVELE1BQU0sQ0FBQyxJQUFNLHVCQUF1QixHQUFHLFVBQUMsY0FBdUI7SUFDN0QsUUFBUSxjQUFjLEVBQUU7UUFDdEIsS0FBSyxnQkFBZ0I7WUFDbkIsT0FBTyx1QkFBdUIsQ0FBQTtRQUNoQyxLQUFLLGVBQWU7WUFDbEIsT0FBTyxzQkFBc0IsQ0FBQTtRQUMvQixLQUFLLGFBQWE7WUFDaEIsT0FBTyxtQkFBbUIsQ0FBQTtRQUM1QjtZQUNFLE9BQU8scUJBQXFCLENBQUE7S0FDL0I7QUFDSCxDQUFDLENBQUEifQ==